import { useMemo } from 'react';
import { AiUsageData } from 'shared/services/settingsApi';
import { LeaderboardRow, SessionRow, SpendDatum } from './types';

export type AiUsageViewModel = {
  spend: SpendDatum[];
  sessions: SessionRow[];
  leaderboard: LeaderboardRow[];
};

const EMPTY: AiUsageViewModel = { spend: [], sessions: [], leaderboard: [] };

export const useAiUsageViewModel = (
  data: AiUsageData | undefined,
): AiUsageViewModel =>
  useMemo(() => {
    if (!data) {
      return EMPTY;
    }
    return {
      spend: data.spend_by_day.map((d) => ({
        day: d.day,
        agent: d.agent,
        ci: d.ci,
      })),
      sessions: data.sessions.map((s) => ({
        id: s.thread_id,
        title: s.conversation_starter,
        userId: s.user_id,
        name: s.name,
        email: s.email,
        startedAt: s.started_at,
        credits: s.credits,
      })),
      leaderboard: data.leaderboard.map((e) => ({
        userId: e.user_id,
        name: e.name,
        email: e.email,
        credits: e.credits,
        aiRuns: e.ai_runs,
      })),
    };
  }, [data]);
